import { render, staticRenderFns } from "./list.vue?vue&type=template&id=ce09a76a&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=ce09a76a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce09a76a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce09a76a')) {
      api.createRecord('ce09a76a', component.options)
    } else {
      api.reload('ce09a76a', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=ce09a76a&scoped=true", function () {
      api.rerender('ce09a76a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/attribute/list.vue"
export default component.exports